module.exports = __webpack_public_path__ + "static/service15-dcdd8da2e0d4241bb96b3cc068a8d6bd.jpg";